module.exports = require("core-js/library/fn/array/is-array");